// @ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    margin: 16px 0 80px;
    .table-properties {
        tbody {
            max-height: 60vh;
            height: 100%;
            overflow-y: auto;
        }
    }
    .programs {
        display: grid;
        grid-template-columns: 400px auto;
        gap: 32px;
        align-items: flex-end;
        margin: 40px 0;
        div.large.pcom {
            top: auto;
            bottom: 52px;
        }
    }
`;
